'use client';

import { VOICE_PRESETS } from '@/contexts/stories';

export interface VoiceSettings {
  voiceId: string;
  voiceName: string;
  stability: number;
  similarityBoost: number;
}

export const DEFAULT_VOICE_SETTINGS: VoiceSettings = {
  voiceId: VOICE_PRESETS.female.voiceId,
  voiceName: VOICE_PRESETS.female.voiceName,
  stability: 0.5,
  similarityBoost: 0.75,
};
